import React from 'react'
import { Navigate } from 'react-router-dom'

export const IniciativaDetalle: React.FC = () => {
  return <Navigate to="/iniciativas" replace />
}
